import React from 'react';
import { useSnapshot } from 'valtio';
import { datareadStore,datasetStore, videoStore} from '../managers/globalState';
// import { useParams, useLocation } from 'react-router-dom';
import { completeRectangleExport, refreshSelectedRegionData } from './region_select';

const ExportButton = () => {
	const { selectedRegion, hasSelectedRegion, regionData: selectedData } = useSnapshot(datareadStore.state);
	// const { state } = useLocation();
	// const { notFirstPage } = state ?? {};
	// const { currentDataset, currentVS } = useSnapshot(datasetStore.state);
	// const visibleEarthIds = ['viirsToday', 'modisToday', 'modisAquaToday'];
    // const isVisibleEarth = visibleEarthIds.includes(currentDataset?.externalId);
	//  const isSatellites = currentVS?.value === 'satellites';
	//  const { currentVideo, isVideoTexture } = useSnapshot(videoStore.state);
    // const isVisible = notFirstPage && Boolean(currentDataset) && !isVisibleEarth && !isSatellites && !currentVideo && !isVideoTexture;
 
	if (!hasSelectedRegion || !selectedRegion) return null;

	const handleClick = () => {
        // Re-sample for the current dataset and temperature unit before each export.
        refreshSelectedRegionData();
        const { regionData } = datareadStore.state;

		if (!regionData || regionData.length === 0) {
		  alert('لا توجد بيانات للتصدير. يُرجى تحديد المنطقة أولاً.');
		  return;
		}

		const rows = [
			['Value', 'Unit', 'Latitude', 'Longitude', 'Mission/ Satellite Name']];
		for (const { value, units, lat, lon, dataset} of regionData) {
		  rows.push([value, units, lat, lon, dataset]);
		}
	  
		const csvContent = rows
			.map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
			.join('\n');
		const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
	  
		const link = document.createElement('a');
		link.id = 'region_csv_download';
		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'region_data.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		completeRectangleExport(); // Keep navigation locked until Cancel.
	};

	return hasSelectedRegion && (
		<button 
    id="export_select"
		className="rectangle-btn" 
		onClick={handleClick}
	style={{
             backgroundColor: '#2a5e96',
          color: '#fff',
          fontSize: '14px',
          fontWeight: 500,
          height: '32px',
          lineHeight: '20px',
          marginTop: '14px',
          padding: '0 12px',
          textTransform: 'none',
          width: '100%',

	}} >
			تحميل
		</button>
	);
};

export default ExportButton;
